import React from 'react';
import axios from 'axios';
import Card from '~/src/components/Main/Info/Card';
import * as ST from './styled';
import { getPackageChannels } from '~/src/api/promo';
import { resolve } from 'path';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton/styledButton';
import ShopItemCard from '~/src/components/Main/Info/ShopItemCard';
import { ddmmyyyy } from '~/src/helpers/date';

const CATEGORY = {
    NEW: 'new',
    VIEWED: 'viewed',
    CONNECTED: 'active',
    NOCATEGORY: '',
};

const EVENT = {
    event: 'UAevent',
    category: 'Action sale',
};

const GiftCard = (
    {
        item,
        showOfferPopup,
        city,
        ...props
    },
) => {
    const { title, category } = item;
    const { domain } = city;

    const getImage = (item) => {
        return item.picture || item.banner || item.image || '/static/images/gift.png';
    };

    const showOfferInfo = () => {
        const offer = item;
        dataLayerPush({
            ...EVENT,
            action: 'Connect_click',
            label: offer.title,
        });

        if (offer.childOffers) {
            const promises = offer.childOffers.map(offer => {
                if (offer.tvPackageId) {
                    return getPackageChannels(domain,
                        offer.tvPackageId).then(response => {
                        offer.channels = response;
                    });
                } else {
                    resolve();
                }
            });
            axios.all(promises).then(() => {
                showOfferPopup(offer);
            });
        } else if (offer.tvPackageId && !offer.channels) {
            getPackageChannels(domain, offer.tvPackageId)
                .then(response => {
                    offer.channels = response;
                    showOfferPopup(offer);
                });
        } else {
            showOfferPopup(offer);
        }
    };

    const getShortDescription = (item) => {
        let stopDate = '';
        if (item.category === CATEGORY.CONNECTED && item.requestStopDate) {
            const date = new Date(item.requestStopDate);
            stopDate = `<p>Действует до ${ddmmyyyy(date)}</p>`;
        }
        return item.shortDescription || item.body || item.description + stopDate;
    };

    const isConnected = category === CATEGORY.CONNECTED;

    const connectContent = isConnected
        ? <ST.Content>
            <StyledButton type='error' text={'Отключить'} onClick={showOfferInfo}/>
        </ST.Content>
        : <ST.Content>
            <StyledButton type='primary' text={'Подробнее'} onClick={showOfferInfo}/>
        </ST.Content>;

    return (
        <>
            {
                item.isShop
                    ? <ShopItemCard item={item}/>
                    : <Card
                        {...props}
                        headerBlock={false}

                        imageBlock={
                            <ST.GiftImg src={getImage(item)}/>
                        }

                        titleBlock={
                            <ST.GiftTitle>{title}</ST.GiftTitle>
                        }

                        descriptionBlock={
                            <ST.GiftDesc dangerouslySetInnerHTML={{ __html: getShortDescription(item) }}/>
                        }

                        purchaseBlock={
                            connectContent
                        }
                    />
            }
        </>
    );
};

export default GiftCard;
